import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getAllUnitExplore = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/unit/explore?page=${page}&rowsPerPage=${rowsPerPage}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getSearchUnits = (filters, callback) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/search`;
  axios
    .post(url, filters)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

// Promise-based variant used by useInfinityPagination (see FacultyList pattern).
// Errors are rethrown so callers can handle 401 (login-required) via errCallback.
export const searchUnits = async (data) => {
  const axios = AxiosConfigExplore();
  const url = `/unit/v2/search`;
  const res = await axios.post(url, data);
  return res.data;
};

export const getSearchUnitGraph = async (filter) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/search/collaborators_graph`;
  try {
    const res = await axios.post(url, filter);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSuggestSearchUnits = (params, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/unit/suggest/${params}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUnitSummaryById = async (id) => {
  const axios = AxiosConfigExplore();
  const url = `/unit/summary?unit_id=${id}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitKeywordsById = async ({
  id,
  rootConcept,
  timeFilter = "all",
  granularityLevel,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/keyword_cloud?unitId=${id}&time_filter=${timeFilter}`;

  if (rootConcept?.length > 0) {
    let params = new URLSearchParams();
    rootConcept.forEach((e) => {
      if (e) {
        params.append("rootConcept", e.value);
      }
    });
    url += `&${params.toString()}`;
  }

  if (granularityLevel) {
    url += `&granularityLevel=${granularityLevel}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitGrantsKeywordsById = async ({
  id,
  rootConcept,
  timeFilter = "all",
  granularityLevel,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/grants_keyword_cloud?unitId=${id}&time_filter=${timeFilter}`;

  if (rootConcept?.length > 0) {
    let params = new URLSearchParams();
    rootConcept.forEach((e) => {
      if (e) {
        params.append("rootConcept", e.value);
      }
    });
    url += `&${params.toString()}`;
  }

  if (typeof granularityLevel === "number") {
    url += `&granularityLevel=${granularityLevel}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitFacultyById = async ({
  id,
  keyword = [],
  timeFilter = "all",
  page = 0,
  rowsPerPage = 10,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/faculty?unitId=${id}&time_filter=${timeFilter}&page=${page}&rowsPerPage=${rowsPerPage}`;

  if (keyword?.length > 0) {
    let params = new URLSearchParams();
    keyword.forEach((e) => {
      if (e) {
        params.append("keyword", e.value);
      }
    });
    url += `&${params.toString()}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitPublicationsById = async ({
  id,
  keyword = [],
  timeFilter = "all",
  orderBy,
  order,
  page = 0,
  rowsPerPage = 10,
  numPages,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/publication?unitId=${id}&time_filter=${timeFilter}&page=${page}&rowsPerPage=${rowsPerPage}&order_by=publication_year&order=desc`;

  if (keyword?.length > 0) {
    let params = new URLSearchParams();
    keyword.forEach((e) => {
      if (e) {
        params.append("keyword", e.value);
      }
    });
    url += `&${params.toString()}`;
  }

  if (numPages) {
    url += `&numPages=${numPages}`;
  }

  if (orderBy) {
    url += `&order_by=${orderBy}`;
  }
  if (order) {
    url += `&order=${order}`;
  }
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitAwardedGrantsById = async ({
  id,
  keyword = [],
  timeFilter = "all",
  orderBy,
  order,
  page = 0,
  rowsPerPage = 10,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/awarded_grants?unitId=${id}&time_filter=${timeFilter}&page=${page}&rowsPerPage=${rowsPerPage}`;

  if (keyword?.length > 0) {
    let params = new URLSearchParams();
    keyword.forEach((e) => {
      if (e) {
        params.append("keyword", e.value);
      }
    });
    url += `&${params.toString()}`;
  }

  if (orderBy) {
    url += `&order_by=${orderBy}`;
  }
  if (order) {
    url += `&order=${order}`;
  }
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitCollaboratorsById = async ({
  id,
  keyword = [],
  mode = "all",
  page = 0,
  rowsPerPage = 10,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/collaborators?unitId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;

  if (keyword?.length > 0) {
    let params = new URLSearchParams();
    keyword.forEach((e) => {
      if (e) {
        params.append("keyword", e.value);
      }
    });
    url += `&${params.toString()}`;
  }
  if (mode) {
    url += `&mode=${mode}`;
  }
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitCollaboratorsGraphById = async ({
  id,
  keyword = [],
  mode = "all",
  top_k,
  top_k_edges,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/unit/collaborators_graph?unitId=${id}`;

  if (keyword?.length > 0) {
    let params = new URLSearchParams();
    keyword.forEach((e) => {
      if (e) {
        params.append("keyword", e.value);
      }
    });
    url += `&${params.toString()}`;
  }
  if (mode) {
    url += `&mode=${mode}`;
  }
  if (top_k) {
    url += `&top_k=${top_k}`;
  }
  if (top_k_edges) {
    url += `&top_k_edges=${top_k_edges}`;
  }
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUnitTopRankingKeywords = async (args) => {
  const { id } = args;
  const axios = AxiosConfigExplore();
  const url = `/unit/top_ranking_keywords?unitId=${id}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getUnitInternationalCollaboratorsById = async ({
  id,
  country = [],
  keyword = [],
  timeFilter,
}) => {
  const axios = AxiosConfigExplore();
  const searchParams = new URLSearchParams();
  searchParams.append("unitId", id);
  country?.forEach((c) => searchParams.append("country", c));
  keyword?.forEach((e) => searchParams.append("keyword", e));
  if (timeFilter) {
    searchParams.append("timeFilter", timeFilter);
  }
  const url = `/unit/international_collaborators/general?${searchParams.toString()}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getUnitInternationalCollaboratorsByCountry = async ({
  id,
  country,
  keyword = [],
  page = 0,
  rowsPerPage = 10,
  timeFilter,
  getAll = false,
}) => {
  const axios = AxiosConfigExplore();
  const searchParams = new URLSearchParams();
  searchParams.append("unitId", id);
  searchParams.append("country", country);
  keyword?.forEach((e) => searchParams.append("keyword", e));
  searchParams.append("page", page);
  searchParams.append("rowsPerPage", rowsPerPage);
  searchParams.append("getAll", getAll);
  if (timeFilter) {
    searchParams.append("timeFilter", timeFilter);
  }
  const url = `/unit/international_collaborators/details?${searchParams.toString()}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
